var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMerge = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 6.9a.9.9 0 0 1 .9-.9h2.108a4.5 4.5 0 0 1 3.184 1.318l2.992 2.991a2.7 2.7 0 0 0 1.908.791h3.836l-3.564-3.564a.9.9 0 0 1 1.273-1.272l5.1 5.1a.9.9 0 0 1 0 1.272l-5.1 5.1a.9.9 0 1 1-1.272-1.272L18.93 12.9h-3.836a2.7 2.7 0 0 0-1.91.79l-2.991 2.992A4.5 4.5 0 0 1 7.008 18H4.9a.9.9 0 1 1 0-1.8h2.108a2.7 2.7 0 0 0 1.91-.79l2.991-2.992a4.4 4.4 0 0 1 .483-.418 5 5 0 0 1-.483-.418L8.918 8.591A2.7 2.7 0 0 0 7.01 7.8H4.9a.9.9 0 0 1-.9-.9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMerge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/merge.08c7af5e.svg";